
import React, { useState, useEffect } from "react";
import PageHeader from "../../components/PageHeader";
import CategoryItemUpdateComponent from "../../components/CategoryItem/CategoryItemUpdate";
import Loader from "react-loader-spinner";
import { viewCategoryItemAction } from "../../actions";
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";

function CategoryItemUpdate({ viewCategoryItemAction }) {

    const params = useParams();
    const id = params.id;
    const [categoryItem, setCategoryItemData] = useState(null);
   
    useEffect(() => {
        window.scrollTo(0, 0);
    });

    useEffect(() => {
        if (id) {
            viewCategoryItemAction({ id: id }, (err, response) => {
                if (!err) {
                    setCategoryItemData(response.data.data);
                }
            });
        }
    }, [id]);

    return (
        <div
            style={{ flex: 1 }}
            onClick={() => {
                document.body.classList.remove("offcanvas-active");
            }}
        >
            <div>
                <div className="container-fluid">
                    {categoryItem && <PageHeader
                        HeaderText="Category Item Update"
                        Breadcrumb={[
                            { name: "Categories", navigate: "/categories" },
                            { name: categoryItem.categoryId.title, navigate: `/categories/view/${categoryItem.categoryId._id}` },
                            { name: 'Sub Category Items', navigate: `/category-item/${categoryItem.categoryId._id}` },
                            { name: categoryItem.title, navigate: `` },
                        ]}
                    />}
                    <div className="row clearfix justify-content-center">
                        {categoryItem ? <CategoryItemUpdateComponent categoryItem={categoryItem} />
                            : <div className="text-center" style={{marginTop: "50px"}}>
                                <Loader
                                    type="Bars"
                                    color="#00BFFF"
                                    height={100}
                                    width={100}
                                    timeout={3000} //3 secs
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(null, { viewCategoryItemAction })(CategoryItemUpdate)
